import "../CSSFiles/PopUpCode.css"
import React, { useRef } from 'react';
import loading_gif from "../Images/loading_gif.gif"

export const PopUpCode = (props) => {

    const PopUpRef = useRef(null)


    const CloseOutHandler = () => {
        PopUpRef.current.classList.add("disp_none")
        window.scrollTo(0, 0);
    }

    const VisitHandler = () => {
        PopUpRef.current.classList.add("disp_none")
        document.getElementById('contact-info').scrollIntoView({ behavior: 'smooth'});
    }


    return <div  className="pop-up disp_none" id="code-popup" ref={PopUpRef}>
        <div className="pop-up-screen code-screen">
            {!props.code && <h3> Setting appointment...</h3>}
            {props.code && <h3> You're all set!</h3>}
            {!props.code && <img src={loading_gif} alt="Generating code"/>}
            {props.code && props.user_origin == "facebook_synthetic_oil_deal" &&  <p> Come to our shop at  <a target="_blank" href="https://www.google.com/maps?sca_esv=d631dcfb1451b593&rlz=1C1RXQR_enUS1121US1121&sxsrf=AHTn8zq58cpOpiyUcD6xCyyk9uoTNx9jtg:1747609796857&lsig=AB86z5XHPavrWsoUOa2JQSloIrJv&biw=1920&bih=945&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KZch2FUAW7aJMdmvrkcGufv3&daddr=9106+Euclid+Ave,+Manassas,+VA+20110">9106 Euclid Ave</a> to claim your <span className="bigger-text-code"> $35 </span> Synthetic Oil Change and free checkup!</p>}
            {props.code && props.user_origin != "facebook_synthetic_oil_deal" &&  <p> Come to our shop at <a target="_blank" href="https://www.google.com/maps?sca_esv=d631dcfb1451b593&rlz=1C1RXQR_enUS1121US1121&sxsrf=AHTn8zq58cpOpiyUcD6xCyyk9uoTNx9jtg:1747609796857&lsig=AB86z5XHPavrWsoUOa2JQSloIrJv&biw=1920&bih=945&um=1&ie=UTF-8&fb=1&gl=us&sa=X&geocode=KZch2FUAW7aJMdmvrkcGufv3&daddr=9106+Euclid+Ave,+Manassas,+VA+20110">9106 Euclid Ave</a> to claim <span className="bigger-text-code"> 20% off</span> all general services!</p>}
            
            
            
            <div className="pop-up-buttons">
                <button className="visit-us" onClick={CloseOutHandler}> Got it!</button>
            </div>
        </div>
    </div>
}